//Note: Important!!!
//import the class here, not the object
import {HttpService} from 'service/HttpService';

import {OrderAction, UserAction} from 'AppAction';
import AppConstants from 'AppConstants';
import Dispatcher from 'service/Dispatcher';


const SUBMIT_ORDER_MSG = "We have received your order. You will get a call from our operator soon.";
const BASE_URL = AppConstants.BASE_API_URL+"/order";

class OrderAPI extends HttpService { 

	_handleOrderSubmission(response, callback) {
		//API can return session if user chose to Guest
		const session = response.data.session;
		if(session) {
			const bearerToken = session['bearer'];
			const user = session['user'];
			const expiresOn = session['expiresOn'];

			Dispatcher.dispatch({
				type: UserAction.LOGIN_SUCCESS,
				user: user,
				token: bearerToken,
				expiresOn: expiresOn
			});
		}

		Dispatcher.dispatch({
			type: OrderAction.PLACE_ORDER,
			order: response.data
		});

		Dispatcher.dispatchAnAlert(SUBMIT_ORDER_MSG);
		callback(true);
	}

	placeOrder(orderReq, callback) {
		const url = orderReq.isBulkOrder? "/bulk": "";
		this.post(url, orderReq, response => {
			this._handleOrderSubmission(response, callback);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false, null);
		});
	}
	
	placeCustomOrder(orderReq, customerImage, callback) {
		let formData = new FormData();
		formData.append("orderReqJson", JSON.stringify(orderReq));
		formData.append("customerImageFile", customerImage);

		let headers = this.getHeaders();
		headers['content-type'] = 'multipart/form-data';

		this.axios({
			url: "/custom",
			method: 'post',
			data: formData,
			headers: headers
		}).then(response => {
			this._handleOrderSubmission(response, callback);
		}).catch(response => {
			callback(false);
			this.defaultErrorHandler(response);
		});
	}


	validateDiscountCoupon(couponCode, productId, callback) {
		this.post("/coupon/"+couponCode+"/validate?productId="+productId, null, response => {
			callback(true, response.data);
			Dispatcher.dispatchClearAlert();
        }, error => {
			this.defaultErrorHandler(error);
			callback(false);
		});
	}

    closeOrder(orderCloseRequest, callback) {
        super.post("/close", orderCloseRequest, response => {
            Dispatcher.dispatchAnAlert(response.data);
            callback();
        });
    }

    cancelOrder(order, cancelledReason, stockProductId, callback) {
		const cancelRequest = {orderId: order.orderId, cancelledReason: cancelledReason, stockProductId: stockProductId};

		this.post("/cancel", cancelRequest, response => {
			Dispatcher.dispatch({
				type: OrderAction.UPDATE_ORDER_STATE,
				order: order,
				newState: AppConstants.ORDER_STATE.CANCELLED.value
			});
			
			Dispatcher.dispatchAnAlert(response.data);
			callback(true);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false);
		});
    }
    

    updateOrderState(order, orderState, stockProductId, callback) {
        const stateUpdateRequest = {orderId: order.orderId, newState: orderState, stockProductId: stockProductId};
		this.post("/updateState", stateUpdateRequest, response => {
			Dispatcher.dispatch({
				type: OrderAction.UPDATE_ORDER_STATE,
				order: order,
				newState: orderState
			});

			Dispatcher.dispatchAnAlert(response.data);
			callback(true);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false);
		});
	}
}


export default new OrderAPI(BASE_URL);


// WEBPACK FOOTER //
// ./src/service/api/OrderAPI.js